<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="575px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Office Location"
      text="Edit Office Location"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="py-0"
            >
              <v-autocomplete 
                v-model="localOfficeLocation.company_uid"
                label="Company"
                :items="companies"
                item-text="name"
                item-value="id"  
              />  
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-autocomplete 
                v-model="localOfficeLocation.branch_uid"
                label="Branch"
                :items="filteredBranch"
                item-text="branch_name"
                item-value="branch_uid"  
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="localOfficeLocation.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>
            
            <v-col cols="12">
              <GmapMap
                :center="location"
                :zoom="15"
                map-type-id="roadmap"
                style="width: 500px; height: 300px"
                :options="{
                  zoomControl: false,
                  mapTypeControl: false,
                  scaleControl: false,
                  streetViewControl: false,
                  rotateControl: false,
                  fullscreenControl: false,
                  disableDefaultUI: false
                }"
              >
                <GmapMarker
                  :position="location"
                  :clickable="true"
                  :draggable="true"
                  @dragend="getCoordinates($event.latLng)"
                />
              </GmapMap>
            </v-col>
          </v-row>
        </v-container>
      </form> 

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      officeLocation: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localOfficeLocation: null,
        companies: [],
        branches: [],
      }
    },
    computed: {
      location () {
        if (!this.officeLocation) return { lat: 0, lng: 0 }
        return {
          lat: Number((this.localOfficeLocation || {}).latitude || 0),
          lng: Number((this.localOfficeLocation || {}).longitude || 0),
        }
      },

      filteredBranch () {
        if (this.branches.length < 0) return
        return this.branches.filter(branch => { return branch.company_uid === this.localOfficeLocation.company_uid })
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.$api.companies().list()
          .then(res => {
            this.companies = res.data
          })
        this.$api.branches().list()
          .then(res => {
            this.branches = res.data
          })

        this.localOfficeLocation = { ...this.officeLocation }
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            this.$api.officeLocations().update(this.localOfficeLocation.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: 'Office Location updated successfully' })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
   
      getCoordinates (location) {
        this.localOfficeLocation.latitude = location.lat()
        this.localOfficeLocation.longitude = location.lng()
      },

      prepareFormData () {
        return {
          name: this.localOfficeLocation.name,
          latitude: this.localOfficeLocation.latitude,
          longitude: this.localOfficeLocation.longitude,
          branch_uid: this.localOfficeLocation.branch_uid,
          company_uid: this.localOfficeLocation.company_uid,
        }
      },
    },
  }
</script>
